import { render, staticRenderFns } from "./StatForm.vue?vue&type=template&id=0f6448a9&"
import script from "./StatForm.vue?vue&type=script&lang=js&"
export * from "./StatForm.vue?vue&type=script&lang=js&"
import style0 from "./StatForm.vue?vue&type=style&index=0&id=0f6448a9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports